import { render, staticRenderFns } from "./ModalPedidoDocumentos.vue?vue&type=template&id=67b62e86"
import script from "./ModalPedidoDocumentos.vue?vue&type=script&lang=js"
export * from "./ModalPedidoDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports